import Vue from "vue";
import { ConnectionQuality } from "livekit-client";

export class LiveKitQualityController {
    private _qualityStatus: Record<string, ConnectionQuality> = Vue.observable({});

    constructor(private readonly localUserId: number) {
    }

    get qualityStatus() {
        return this._qualityStatus;
    }

    setQuality(identity: string, quality: ConnectionQuality) {
        Vue.set(this._qualityStatus, identity, quality);
    }

    remove(identity: string) {
        Vue.delete(this._qualityStatus, identity);
    }

    userQuality(identity: string, defaultValue: string = ConnectionQuality.Unknown) {
        return this._qualityStatus[identity] ?? defaultValue;
    }

    localUserQuality() {
        return this.userQuality(this.localUserId.toString());
    }

    hasLocalQuality() {
        return Boolean(this._qualityStatus[this.localUserId.toString()]);
    }

    clear() {
        this._qualityStatus = null as any;
    }
}
